import React, { useEffect, useState } from 'react'
import { ApiConstants } from '../constants/ApiConstants'
import useMakeRequest from '../utils/ApiHelper'
import FrontLoader from '../component/layout/FrontLoader'
import { useNavigate } from 'react-router-dom'
import { object } from 'yup'
import { LanguageConstants } from '../constants/LanguageConstants'

function AddressChange(props:any) {
    const addressList = useMakeRequest()
    const addressUpdate = useMakeRequest()
    const [addressData , setAddressData] = useState<any>({})
    const [error , setError] = useState('')
    const navigate = useNavigate()

    useEffect(() => {
        addressList.makeRequest({ url: ApiConstants?.AddressList, toastStatus: false })
    }, [])
   const handleAddressChange =()=>{
    if(Object.keys(addressData).length <= 0){
       return setError('Please select address')
    }else{   
    const payload ={
        address_id:addressData?.id,
        quotation_id:props?.data?.quotation_id
    }
    addressUpdate.makeRequest({payload, url: ApiConstants?.QuotesAddressUpdate, toastStatus: true }) 
}
   }
   useEffect(()=>{
   if(addressUpdate?.status){
    setAddressData({})
    navigate('/my-quotation')
    props?.setAddressChangeShow(false)
   }
   },[addressUpdate?.status])

   const NavigateToNewAddress =()=>{
       props?.setAddressChangeShow(false)
      props?.setNewAddress(true)
   }

    return (
        <>
            {(addressList?.loading || addressUpdate?.loading) ? <FrontLoader /> : null}
            <div className="modal fade com-modal short-modal select-address-modal show" id="selectAddressModal" aria-labelledby="selectAddressModalLabel" aria-hidden="true" style={{ display: "block" }} >
                <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="selectAddressModalLabel">{LanguageConstants?.SELETE_ADDRESS}</h5>
                            <button onClick={()=>props?.setAddressChangeShow(false)} type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"><i className="icon-close-square" /></button>
                        </div>
                        <div className="modal-body pb-0 text-start">
                            {addressList?.data?.data?.rows?.map((res: any, i: any) => (

                                <div className="select-address" onClick={()=>setAddressData(res)} >
                                    <input type="radio" id={`address-${i}`} name="selectAddressName" />
                                    <label htmlFor={`address-${i}`} className="select-address-choose">
                                    {`${res.street_line} ,${res.loaction_type == "1" ? "Residential" : 'Laboral'}`}
                                        <span className="choose-tick"><i className="icon-tick-2"></i></span>
                                    </label>
                                </div>
                            ))}
                           <p className='text-error-new'>{error}</p>
                            <button onClick={()=>NavigateToNewAddress()}  type="button" className="add-n-address">{LanguageConstants?.NEWADDRES}</button>

                        </div>
                        <div className="modal-footer">
                            <button onClick={()=>handleAddressChange()} className="round-btn m-0 w-100" >{LanguageConstants?.COUNTINUE}</button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default AddressChange